import React from 'react';
import { Link } from 'react-router';
import moment from 'moment';

export default () => {
    var start = moment('2017-02-11T08:55:00-06:00'),
        now = moment(),
        tripLead,
        eta;

    if (start.diff(now) >= 0) {
        tripLead = 'Next trip:';
        eta = (
            <p className="lead">
                <span className="text-muted">T-minus:</span> { start.from(now, true) }
            </p>
        );
    }
    else if (start.diff(now) < 0) {
        tripLead = 'Current trip:';
        eta = (
            <p className="lead">
                <span className="text-muted">Trip started:</span> { start.from(now) }
            </p>
        );
    }

    return (
        <div className="container jumbotron-container vertical-center">
            <section className="jumbotron horizontal-center">
                <div className="container text-xs-center">
                    <h1 className="jumbotron-heading" style={ { fontSize: '4rem' } }><i className="fa fa-map-o"></i> Walkabout</h1>
                    <p className="lead text-muted">
                        Check out my <Link to="/itinerary">itinerary</Link>, then watch my <Link to="/journal">journal</Link> for updates!
                    </p>
                    <p className="lead">
                        <span className="text-muted">{ tripLead }</span> Koalas and Kiwis
                    </p>
                    { eta }
                </div>
            </section>

            <footer className="footer text-muted">
                <div className="container text-xs-center">
                    <p className="hidden-sm-down nowrap">
                        &copy;2017 William H. Dibbern III // @GotDibbs
                    </p>
                    <p className="hidden-md-up nowrap">
                        &copy; 2017 GotDibbs
                    </p>
                </div>
            </footer>
        </div> 
    );
};


// WEBPACK FOOTER //
// ./src/app/components/index_home.jsx